/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KpiValue } from '../../models/kpi-value';

export interface GetAllKpis$Params {
  productionOrderId: number;
}

export function getAllKpis(http: HttpClient, rootUrl: string, params: GetAllKpis$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KpiValue>>> {
  const rb = new RequestBuilder(rootUrl, getAllKpis.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KpiValue>>;
    })
  );
}

getAllKpis.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetAllKpis';
